import { EntityService } from '../../../service/EntityService';

export class WrongInvoiceService extends EntityService {

  static entity = 'app/wrong-invoice';

  static getDetail(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/wrong-invoice-detail`).then(res => res.data);
  }

  static downloadXml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/download-xml/${id}`, { responseType: 'blob' }).then(res => res.data);
  }

  //TODO: Sai chính tả
  static getPdfUrl(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/downloaf-pdf`).then(res => res.data);
  }
  //TODO: Sai chính tả
  static getHtmlUrl(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/downloadf-html`).then(res => res.data);
  }
}
